import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.device-management', {
        url: '/device_management',
        component: 'userDevices',
        resolve: {devices},
    })
}

/** @ngInject */
function devices(DeviceManagement) {
    return DeviceManagement.get().$promise;
}



// WEBPACK FOOTER //
// ./src/portal/states/user/device-management/device-management.state.js